import React from 'react';
import {
  Box,
  Button,
  Card,
  CardContent,
  Checkbox,
  Container,
  FormControlLabel,
  FormGroup,
  TextField,
  Typography,
} from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

export default function CustomerIntake() {
  return (
    <Container disableGutters sx={{ mt: 0 }}>
      <Box
        sx={{
          maxWidth: 'md',
          mx: 'auto',
          textAlign: 'left',
          pt: { xs: 0.5, md: 0.5 },
          pb: { xs: 0.5, md: 0.5 },
          display: 'flex',
          flexDirection: 'column',
          gap: 1.5,
        }}
      >
        <Card
          sx={{
            border: '1px solid #97999B',
            borderRadius: 2,
            boxShadow: '0 18px 40px rgba(0, 0, 0, 0.08)',
          }}
        >
          <CardContent sx={{ p: { xs: 2, md: 2.5 } }}>
            <Typography variant="h4" component="h1">
              Intake Form
            </Typography>
            <Typography variant="body1" sx={{ mt: 1 }}>
              Provide a few details so we can begin your VeraBIND Tau order.
            </Typography>

            <Box
              sx={{
                display: 'grid',
                gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' },
                gap: 2,
                mt: 2,
              }}
            >
              <TextField label="First name" placeholder="Jane" fullWidth size="small" />
              <TextField label="Last name" placeholder="Smith" fullWidth size="small" />
              <TextField label="Cell phone number" placeholder="(555) 123-4567" fullWidth size="small" />
              <TextField
                label="Date of birth"
                type="date"
                fullWidth
                size="small"
                InputLabelProps={{ shrink: true }}
              />
            </Box>

            <Typography variant="subtitle1" sx={{ mt: 2, fontWeight: 700 }}>
              Shipping Address
            </Typography>
            <Box
              sx={{
                display: 'grid',
                gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' },
                gap: 2,
                mt: 1,
              }}
            >
              <TextField
                label="Shipping address line 1"
                placeholder="123 Oak Street"
                fullWidth
                size="small"
              />
              <TextField
                label="Shipping address line 2"
                placeholder="Apt, suite, unit (optional)"
                fullWidth
                size="small"
              />
              <TextField label="City" placeholder="San Diego" fullWidth size="small" />
              <TextField label="State" placeholder="CA" fullWidth size="small" />
              <TextField label="ZIP code" placeholder="92101" fullWidth size="small" />
            </Box>

            <FormGroup sx={{ mt: 1.5 }}>
              <FormControlLabel
                control={<Checkbox />}
                label="It is okay to email me updates about the status of this test."
              />
            </FormGroup>

            <Box sx={{ mt: 2 }}>
              <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>
                Questionnaire (check all that apply)
              </Typography>
              <FormGroup sx={{ mt: 1 }}>
                <FormControlLabel
                  control={<Checkbox />}
                  label="Has anyone in your family suffered from cognitive impairment (CI)?"
                />
                <FormControlLabel
                  control={<Checkbox />}
                  label="Are you concerned about cognitive impairment (CI) for yourself?"
                />
              </FormGroup>
            </Box>

            <Box sx={{ mt: 2, display: 'flex', justifyContent: 'flex-end' }}>
              <Button
                variant="contained"
                color="primary"
                component={RouterLink}
                to="/mock/customer-assign-provider"
                sx={{
                  fontWeight: 700,
                  letterSpacing: '0.02em',
                  boxShadow: '0 12px 22px rgba(0, 118, 127, 0.28)',
                  py: 1.1,
                  px: 3,
                }}
              >
                Assign Provider
              </Button>
            </Box>
          </CardContent>
        </Card>
      </Box>
    </Container>
  );
}
